<template>
    <div class="tb_st03 mt-10 pc-visible">
        <div class="thead">
            <table>
                <caption>리스트헤더</caption>
                <colgroup>
                    <col style="width: 25%;">
                    <col style="width: 25%;">
                    <col style="width: 25%;">
                    <col style="width: 25%;">
                </colgroup>
                <thead>
                <tr>
                    <th>기준일</th>
                    <th>신규확진자</th>
                    <th>누적자가격리자</th>
                    <th>누적검사건수</th>
                </tr>
                <!--
                <tr>
                    <th>기준일</th>
                    <th>신규확진자</th>
                    <th>서울시 신규확진자</th>
                    <th>서울시 누적확진자</th>
                </tr>
                -->
                </thead>
            </table>
        </div>
        <div class="tbody full scroll">
            <table>
                <caption>리스트내용</caption>
                <colgroup>
                    <col style="width: 25%;">
                    <col style="width: 25%;">
                    <col style="width: 25%;">
                    <col style="width: 25%;">
                </colgroup>
                <thead style="display: none;">
                <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(covid) in covidTempGangnamList">
                    <td>{{ covid.basdtVal }}</td>
                    <td>{{ covid.confirm  }}</td>
                    <td>{{ covid.isolate }}</td>
                    <td>{{ covid.test }}</td>
                </tr>
                <!--
                <tr v-for="(covid) in covidDaySeoulList">
                    <td>{{ toDateFormat(covid.basdtVal) }}</td>
                    <td>{{ toNumber(covid.val27)  }}</td>
                    <td>{{ toNumber(covid.val48) }}</td>
                    <td>{{ toNumber(covid.val6) }}</td>
                </tr>
                -->
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import gripUtil from "@/libs/grip.util";
import { $_WC, $_TYPE } from '@/confs/common.const.js';

export default {
    computed: {
        ...mapGetters({
            covidGangnamList: 'getCovidGangnamList',
            covidIsolationList: 'getCovidIsolationList',
            covidCheckupLocList: 'getCovidCheckupLocList',
            covidDaySeoulList: 'getCovidDaySeoulList',
        }),
        covidGangnamDateMap(){
            let map = {};
            this.covidGangnamList.forEach(d => {
                let key = d.basdtVal.substring(0, 8);
                if(typeof map[key] === $_TYPE.UNDEF){
                    map[key] = d;
                }
            });
            return map;
        },
        covidIsolationDateMap(){
            return gripUtil.toDict(this.covidIsolationList, 'basdtVal');
        },
        covidTestDateMap(){
            return gripUtil.toDict(this.covidCheckupLocList, 'basdtVal');
        },
        covidTempGangnamList(){
            let list = [];
            let tmpList = [];
            let seq = 0;
            this.covidGangnamList.forEach(covid => {
                if(typeof this.confirmCnt(covid) !== $_TYPE.UNDEF) {
                    let map = {
                        key: covid.basdtVal.substring(0, 8),
                        basdtVal: this.toDate(covid.basdtVal),
                        confirm: this.confirmCnt(covid),
                        isolate: this.isolationCnt(covid.basdtVal),
                        test: this.testCnt(covid.basdtVal),
                        seq: seq,
                    };
                    seq++;
                    tmpList.push(map);
                }
            });

            if(tmpList.length > 0) {
                let keyMap = gripUtil.toDict(tmpList, 'key');

                let currentSeq = 0;
                let covidDate = tmpList[0].key;
                for (let ii = 0; ii < 15; ii++) {
                    let basday = new Date(covidDate.substring(0, 4) + '-' + covidDate.substring(4, 6) + '-' + covidDate.substring(6, 8));
                    basday.setDate(basday.getDate() - ii);
                    let key = basday.format('yyyyMMdd');
                    if (typeof keyMap[key] !== $_TYPE.UNDEF) {
                        list[ii] = keyMap[key];
                        currentSeq = keyMap[key].seq;
                    } else {
                        let replaceBasdtVal = gripUtil.formatDate(key, 'MM-dd 18:00');
                        let map = {
                            key: tmpList[currentSeq].key,
                            basdtVal: replaceBasdtVal,
                            confirm: tmpList[currentSeq].confirm,
                            isolate: tmpList[currentSeq].isolate,
                            test: tmpList[currentSeq].test,
                        };
                        list[ii] = map;
                    }
                }
            }
            return list;
        },
    },
    methods: {
        toDate(basdtVal){
            return gripUtil.formatDate(basdtVal, 'MM-dd HH:mm');
        },
        toDateFormat(basdtVal){
            return gripUtil.formatDate(basdtVal, 'MM-dd');
        },
        toNumber(val){
            return gripUtil.toCurrency(val);
        },
        confirmCnt(covid){
            if(typeof covid.basdtVal !== $_TYPE.UNDEF && covid.basdtVal !== '') {
                let basdtVal = covid.basdtVal.substring(0, 4) + '-' + covid.basdtVal.substring(4, 6) + '-' + covid.basdtVal.substring(6, 8);
                let basday = new Date(basdtVal);
                let searchDay = new Date(basday - (3600000 * 24 * 1));
                let searchFromDate = searchDay.format('yyyyMMdd');

                if(typeof this.covidGangnamDateMap[searchFromDate] !== $_TYPE.UNDEF) {
                    return this.toNumber(Number(covid.val5) - Number(this.covidGangnamDateMap[searchFromDate].val5));
                }
            }
        },
        isolationCnt(covidDate){
            // let basdtVal = covidDate.substring(0, 4) + '-' + covidDate.substring(4, 6) + '-' + covidDate.substring(6, 8);
            // let basday = new Date(basdtVal);
            // let searchDay = new Date(basday - (3600000 * 24 * 1));
            // let searchFromDate = searchDay.format('yyyyMMdd');

            let searchFromDate = covidDate.substring(0, 8);
            if(typeof this.covidIsolationDateMap[searchFromDate] !== $_TYPE.UNDEF) {
                return this.toNumber(this.covidIsolationDateMap[searchFromDate].allCnt);
            }
            return '-';
        },
        testCnt(covidDate){
            let orgDate = covidDate.substring(0, 8);
            let basdtVal = covidDate.substring(0, 4) + '-' + covidDate.substring(4, 6) + '-' + covidDate.substring(6, 8);
            let basday = new Date(basdtVal);
            let searchDay = new Date(basday - (3600000 * 24 * 1));
            let searchFromDate = searchDay.format('yyyyMMdd');

            // if(typeof this.covidTestDateMap[orgDate] !== $_TYPE.UNDEF && typeof this.covidTestDateMap[searchFromDate] !== $_TYPE.UNDEF) {
            //     return this.toNumber(Number(this.covidTestDateMap[orgDate].val2) - Number(this.covidTestDateMap[searchFromDate].val2));
            // }
            if(typeof this.covidTestDateMap[orgDate] !== $_TYPE.UNDEF) {
                return this.toNumber(this.covidTestDateMap[orgDate].val2);
            }
            return '-';
        },
    },
};
</script>
